import React, { useEffect, useState } from 'react';
import '../../styles/Admin/admin_alumniDetail.css';
import { FaTwitter, FaFacebook, FaGithub, FaLinkedin } from 'react-icons/fa';
import { BiChat, BiNotepad } from 'react-icons/bi';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { displaySnackbar } from '../../utilities';
import { BASE_URL } from '../../settings';

import Admin_AlumniChat from './Admin_AlumniChat/Admin_AlumniChat';

export default function Admin_AlumniDetail({ alumni, fetchAllAlumni }) {
    const [tab, setTab] = useState('Details');
    const [fetched_alumni, setFetchedAlumni] = useState(alumni || {});
    const navigate = useNavigate();
    const { clientWidth } = document.body;

    useEffect(() => {
        // 👇️ apply a class to main top nav bar to hide it
        let mainNavBar = document.querySelector('._3drDv.MainNavBar');
        if (mainNavBar) mainNavBar.style.display = 'none';

        window.scrollTo({ top: 0, behavior: 'smooth' });

        let pathname = location.pathname.split('/');
        let id = pathname[pathname.length - 1];

        fetch(`http://localhost:5000/alumni/read`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id }),
        })
            .then(async (result) => {
                let response = await result.json();
                let the_alumni = response?.alumni;
                setFetchedAlumni(the_alumni);
            })
            .catch((error) => {
                console.log(error?.message, '\n', error);
            });
    }, []);

    // 👇️ handler to suspend an alumni
    const suspendAlumni = async () => {
        fetch(`${BASE_URL}/alumni/update`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ...fetched_alumni,
                id: fetched_alumni?.uuid,
                suspended: !fetched_alumni?.suspended,
                // firstName: fetched_alumni?.firstName,
                // lastName: fetched_alumni?.lastName,
                // username: fetched_alumni?.username,
                // email: fetched_alumni?.email,
            }),
        })
            .then(async (result) => {
                let response = await result.json();

                if (response?.errorMsg) {
                    displaySnackbar(response?.errorMsg, true, 'Ok', () => {});
                } else {
                    displaySnackbar(response?.msg, false, 'Ok', () => {});
                    // fetchAllAlumni();
                    setTimeout(() => {
                        location.reload();
                    }, 1500);
                }
            })
            .catch((error) => {
                console.log(error?.message, '\n', error);
            });
    };

    return (
        <div className='alumni-detail'>
            {/* go back button */}
            <button onClick={() => navigate('/admin.console/alumni')}>👈️ Go Back</button>

            {/* header bar */}
            <div className='alumni-detail-header-bar'>
                <div className='left'>
                    <h1>Alumni Profile</h1>
                </div>
                <div className='right'>
                    <button
                        style={{ backgroundColor: tab === 'Details' ? 'blue' : 'darkblue' }}
                        onClick={() => setTab('Details')}
                    >
                        <span>Details {<BiNotepad size={20} />}</span>
                    </button>
                    {/* <button
                        style={{ backgroundColor: tab === 'Message' ? 'blue' : 'darkblue' }}
                        onClick={() => setTab('Message')}
                    >
                        <span>Chat {<BiChat size={20} />}</span>
                    </button> */}
                </div>
            </div>

            {/* alumni content */}
            <div className='alumni-detail-main-content'>
                {tab === 'Details' ? (
                    <div className='details'>
                        <span className='details-sub-header'>Profile Information</span>

                        <div className='details-content-item smaller'>
                            <span className='title'>avatar</span>
                            {fetched_alumni?.avatar?.length > 0 ? (
                                <div className='admin-alumni-avatar-container'>
                                    <img
                                        alt='alumni avatar'
                                        className='admin-alumni-avatar'
                                        src={`${BASE_URL}/alumni/uploads/get-profile-pic/${fetched_alumni?.avatar}`}
                                    />
                                </div>
                            ) : (
                                // <p className='empty-text'>...</p>
                                <div
                                    className='admin-alumni-avatar-container'
                                    style={{
                                        width: '15rem',
                                        height: '15rem',
                                        border: 'none',
                                    }}
                                >
                                    <img
                                        alt='alumni avatar'
                                        className='admin-alumni-avatar'
                                        src={require('../../images/profile-pictures/face1.jpg')}
                                    />
                                </div>
                            )}
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>Actions</span>
                            {/* <button style={{ backgroundColor: 'orangered' }}>
                                Delete this profile
                            </button> */}
                            <button
                                style={{
                                    backgroundColor: fetched_alumni?.suspended ? 'green' : 'orange',
                                }}
                                onClick={suspendAlumni}
                            >
                                {fetched_alumni?.suspended
                                    ? 'Exonerate this profile'
                                    : 'Suspend this profile'}
                            </button>
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>About</span>
                            {fetched_alumni?.about?.length > 0 ? (
                                <p className='text about'>{fetched_alumni?.about}</p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-items'>
                            <div className='details-content-item'>
                                <span className='title'>id</span>
                                {fetched_alumni?.id > 0 ? (
                                    <p className='text'>{fetched_alumni?.id}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>user id (uuid)</span>
                                {fetched_alumni?.uuid?.length > 0 ? (
                                    <p className='text'>{fetched_alumni?.uuid}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Full name</span>
                                {fetched_alumni?.firstName?.length > 0 ||
                                fetched_alumni?.lastName?.length > 0 ? (
                                    <p className='text'>
                                        {fetched_alumni?.firstName} {fetched_alumni?.lastName}
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Username</span>
                                {fetched_alumni?.username?.length > 0 ? (
                                    <p className='text'>@{fetched_alumni?.username}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Email</span>
                                {fetched_alumni?.email?.length > 0 ? (
                                    <p className='text'>{fetched_alumni?.email}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Mobile</span>
                                {fetched_alumni?.mobile?.length > 0 ? (
                                    <p className='text'>(+263) {fetched_alumni?.mobile}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Class of</span>
                                {fetched_alumni?.classYear?.length > 0 ? (
                                    <p className='text'>
                                        {new Date(fetched_alumni?.classYear).getFullYear()}
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Position</span>
                                {fetched_alumni?.positionName?.length > 0 ? (
                                    <p className='text'>
                                        {fetched_alumni?.positionName || 'Not Employed'}
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div
                                className='details-content-item'
                                style={{
                                    backgroundColor: fetched_alumni?.suspended ? 'orange' : 'green',
                                    color: 'white',
                                }}
                            >
                                <span className='title'>Suspended</span>
                                {fetched_alumni?.suspended != null ? (
                                    <p className='text' style={{ color: '#fff' }}>
                                        {fetched_alumni?.suspended ? 'True' : 'False'}
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Profile created on</span>
                                {fetched_alumni?.createdAt?.length > 0 ? (
                                    <p className='text'>
                                        {moment(new Date(fetched_alumni?.createdAt)).calendar()}
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Profile last updated on</span>
                                {fetched_alumni?.updatedAt?.length > 0 ? (
                                    <p className='text'>
                                        {moment(new Date(fetched_alumni?.updatedAt)).calendar()}
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Social</span>
                                <div className='social-links'>
                                    {fetched_alumni?.facebookLink?.length > 0 ||
                                    fetched_alumni?.githubLink?.length > 0 ||
                                    fetched_alumni?.twitterLink?.length > 0 ||
                                    fetched_alumni?.linkedInLink?.length > 0 ? (
                                        <>
                                            {fetched_alumni?.facebookLink?.length > 0 && (
                                                <a href={fetched_alumni?.facebookLink}>
                                                    <FaFacebook size={30} color='darkblue' />
                                                </a>
                                            )}
                                            {fetched_alumni?.githubLink?.length > 0 && (
                                                <a href={fetched_alumni?.githubLink}>
                                                    <FaGithub size={30} color='black' />
                                                </a>
                                            )}
                                            {fetched_alumni?.twitterLink?.length > 0 && (
                                                <a href={fetched_alumni?.twitterLink}>
                                                    <FaTwitter size={30} color='skyblue' />
                                                </a>
                                            )}
                                            {fetched_alumni?.linkedInLink?.length > 0 && (
                                                <a href={fetched_alumni?.linkedInLink}>
                                                    <FaLinkedin size={30} color='darkblue' />
                                                </a>
                                            )}
                                        </>
                                    ) : (
                                        <p className='empty-text'>...</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* <span className='details-sub-header'>Projects</span> */}

                        {/* <div className='details-project-items'>
                            <div className='details-project-item'>
                                <span className='project-title'>Twitter Clone</span>
                                <span className='project-description'>
                                    A twitter clone made with React.js, Tailwind, Express.js &
                                    Firebase
                                </span>
                                <button>View Project</button>
                            </div>
                        </div> */}
                    </div>
                ) : (
                    <Admin_AlumniChat fetched_alumni={fetched_alumni} />
                )}
            </div>
        </div>
    );
}
